import { computed, defineComponent, inject, onMounted, ref, useCssModule, useRouter } from '@nuxtjs/composition-api';
import { enableRouterForDOMLinks, parseLinksInString } from '~/utils';
export default defineComponent({
    name: 'BoxBlock',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * Article.
         */
        const article = inject('article');
        /**
         * Chunks.
         */
        const chunks = computed(() => {
            return parseLinksInString(props.box.data?.text || '', article?.flink).split(/<!--(.*?)-->/g);
        });
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Root element.
         */
        const rootElement = ref();
        /**
         * Router.
         */
        const router = useRouter();
        function getFlinkFromChunk(chunk) {
            if (!article.flink) {
                return;
            }
            return article.flink[chunk.replace('flink:', '')];
        }
        onMounted(() => {
            if (!rootElement.value) {
                return;
            }
            enableRouterForDOMLinks({
                target: rootElement.value,
                router,
            });
        });
        return {
            article,
            chunks,
            css,
            getFlinkFromChunk,
            rootElement,
        };
    },
});
